// promotion() {
//     let price = this.product.Price;
//     return price.PromotionalPrice;
//   },
//   promotionPercentage() {
//     const price = Number(this.productPrice);
//     const pricePromotion = Number(this.productPricePromotion);

//     return ((1 - pricePromotion / price) * 100).toFixed(0);
//   },
//   productPricePromotion() {
//     return this.promotion.PriceTaxIncl;
//   },
//   productPrice() {
//     if (this.promotion) {
//       return this.productPricePromotion;
//     }
//     return this.product.Price.RegularPrice.PriceTaxIncl;
//   },

export function getMainCatgoryTitle(product, locale) {
  try {
    const seo = product?.Category?.Main?.SEO;
    if (seo) {
      const mainCategory = seo.find((item) => {
        return locale === item.LanguageIsoCode?.toLowerCase();
      });
      if (!mainCategory) {
        return null;
      }
      if (mainCategory.MetaTitle) {
        return mainCategory.MetaTitle;
      }
    }
  } catch (error) { }
  return null;
}

export function getPromotion(product) {
  let price = product.Price;
  return price.PromotionalPrice;
}

export function getProductPrice(product) {
  if (getPromotion(product)) {
    return getPromotion(product).PriceTaxIncl;
  }
  return product.Price.RegularPrice.PriceTaxIncl;
}

export function getVariantSelected(product) {
  const variantSelected = product?.Variant?.find((item) => {
    return item.Selected === true;
  });

  if (variantSelected) {
    return variantSelected?.Combination?.IdProductAttribute;
  }
}
